// src/layouts/MyLayout.js
import React from "react";
import { Layout } from "react-admin";

import CustomMenu from "./CustomMenu";
import CustomAppBar from "./CustomAppBar";   // ← ADD THIS IMPORT

const MyLayout = (props) => (
  <Layout
    {...props}
    menu={CustomMenu}     // Sidebar
    appBar={CustomAppBar}     // ← ADD THIS LINE (Fix)
  />
);

export default MyLayout;
